import { useCallback } from 'react';
import { useUpcomingMaintenanceQuery } from '../../maintenance.queries';

// STD-016: thin wrapper over the TanStack `useUpcomingMaintenanceQuery`. The
// previous hand-rolled `window` CustomEvent bus (maintenance-record-*) is gone —
// mutations invalidate the upcoming/history keys and TanStack auto-refetches.
export const useUpcomingMaintenance = (droneSerial?: string) => {
  const query = useUpcomingMaintenanceQuery(droneSerial);
  const { refetch } = query;

  const refresh = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    upcomingMaintenance: query.data ?? [],
    // Only surface a spinner while actually fetching; an unselected drone
    // (query disabled) is not "loading".
    loading: query.isFetching,
    error: query.isError ? 'Failed to load upcoming maintenance' : null,
    refresh,
  };
};
